import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements OnInit {
  @Input() texts: string[] = []
  @Input() header = ''
  @Input() currentIdx = 0
  @Input() collectionIdx: number
  @Input() item: any

  @Output() currentIdxEvent = new EventEmitter<number>();
  @Output() showInUnifiedChanged = new EventEmitter<number>();

  currentText = ''
  showHideText = 'Ocultar'

  constructor() { }

  ngOnInit(): void {
    this.currentText = this.texts[this.currentIdx]
    this.currentIdxEvent.emit(this.currentIdx);
  }

  changeShowing() {
    this.item.showInUnified = !this.item.showInUnified
    this.showHideText = this.item.showInUnified ? 'Ocultar' : 'Mostrar'
    this.showInUnifiedChanged.emit(this.collectionIdx);
  }

  goAhead() {
    this.currentIdx = (this.currentIdx + 1) % this.texts.length
    this.currentText = this.texts[this.currentIdx]
    this.item.selectedIdx = this.currentIdx
    this.currentIdxEvent.emit(this.currentIdx);
  }

  goBack() {
    this.currentIdx = (this.currentIdx - 1) % this.texts.length
    if (this.currentIdx < 0)
      this.currentIdx = this.texts.length - 1
    this.currentText = this.texts[this.currentIdx]
    this.item.selectedIdx = this.currentIdx
    this.currentIdxEvent.emit(this.currentIdx);
  }

}
